"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlaylists = void 0;
const HLS_ATTRIBUTE_REGEXP = new RegExp('(?:,?)([A-Z0-9-]+?)[=](".*?"|[^",]+)(?=,|s*$)', "g");
function getPlaylists(src) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(src);
        if (!response.ok) {
            return [];
        }
        const manifestString = yield response.text();
        const manifestLines = manifestString.split("\n");
        const playlists = [];
        manifestLines.forEach((line, index) => {
            const playlist = {
                url: undefined,
                width: 0,
                height: 0,
                bitrate: 0,
            };
            if (line.includes("#EXT-X-STREAM-INF")) {
                let valid = false;
                playlist.url = manifestLines[index + 1];
                let group;
                while ((group = HLS_ATTRIBUTE_REGEXP.exec(line)) !== null) {
                    const [, attribute, value] = group;
                    switch (attribute) {
                        case "BANDWIDTH":
                            valid = true;
                            playlist.bitrate = Number(value);
                            break;
                        case "RESOLUTION": {
                            const [width, height] = value.split("x");
                            playlist.width = Number(width);
                            playlist.height = Number(height);
                            break;
                        }
                    }
                }
                if (valid) {
                    playlists.push(playlist);
                }
            }
        });
        return playlists;
    });
}
exports.getPlaylists = getPlaylists;
//# sourceMappingURL=hls.js.map